export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const APP_URL = process.env.REACT_APP_APP_URL;
export const START_URL = `${APP_URL}/start`;
